export const parseToNumberOrNull = (str: string) => {
  const parsed = parseInt(str);

  return isNaN(parsed) ? null : parsed;
};
